import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { merge } from 'lodash'
import {
  WorkingStepDto,
  WorkingStepType,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { ProjectState } from '../../../../store/Project/ProjectTypes'

export const bomItemWorkingStepsReplacer: CaseReducer<
  ProjectState,
  PayloadAction<{
    bomItemId: string
    workingStepType: WorkingStepType
    workingStep: Partial<WorkingStepDto>
  }>
> = (state, action) => {
  if (action.payload.bomItemId === state.activeProject?.id) {
    state.activeProject.workingSteps.forEach((ws) => {
      if (
        ws.primaryWorkingStep === ws.secondaryWorkingStep &&
        ws.primaryWorkingStep === action.payload.workingStepType
      ) {
        ws = merge(ws, action.payload.workingStep)
      }
    })

    return state
  }

  const bomItem =
    state.flatView[action.payload.bomItemId] ||
    state.treeView[action.payload.bomItemId]

  switch (bomItem?.type) {
    case 'AssemblyHeader': {
      bomItem.assembly.assemblyWorkingStepDtos.forEach((ws) => {
        if (
          ws.primaryWorkingStep === ws.secondaryWorkingStep &&
          ws.primaryWorkingStep === action.payload.workingStepType
        ) {
          ws = merge(ws, action.payload.workingStep)
        }
      })
      break
    }
    case 'Assembly':
      bomItem.assemblyWorkingStepDtos.forEach((ws) => {
        if (
          ws.primaryWorkingStep === ws.secondaryWorkingStep &&
          ws.primaryWorkingStep === action.payload.workingStepType
        ) {
          ws = merge(ws, action.payload.workingStep)
        }
      })
      break
    case 'Row': {
      bomItem.workingSteps.forEach((ws) => {
        if (
          ws.primaryWorkingStep === ws.secondaryWorkingStep &&
          ws.primaryWorkingStep === action.payload.workingStepType
        ) {
          ws = merge(ws, action.payload.workingStep)
        }
      })
    }
  }

  return state
}
